import Container from 'components/Container/Container'
import React from 'react'
import { themes } from 'theme/styled'
import { ReportsContentContainer, ReportsLabel } from './Reports.styled'
import Button from 'components/Button/Button'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { useAppDispatch, useAppState } from 'store'
import { transactionActions } from 'store/slices/transactions/transactions.slice'
import { useParams } from 'react-router'

const ReportsPage: React.FC = () => {
  const params = useParams<{ locationId: string }>()
  const { loading } = useAppState(state => state.transaction)
  const dispatch = useAppDispatch()

  const handleCreateReport = async () => {
    await dispatch(transactionActions.createReport(params.locationId))
  }
  return (
    <FacilityFormTemplate>
      <Container
        size="small"
        style={{
          marginTop: 35,
          height: '100%',
          padding: '27px 38px',
          borderRadius: 39,
          border: `1px solid ${themes.Light.colors.borderSecondary}`,
          boxShadow: '0px 0px 10px 5px rgba(0, 0, 0, 0.05)',
        }}>
        <ReportsLabel>Reports</ReportsLabel>
        <ReportsContentContainer>
          <p>Generate Accounts Receivable & Credit Balance Report</p>

          <Button
            rightIconStyle={{
              width: '1rem',
            }}
            preset="ghost"
            variant={'primary'}
            text={'Generate Report'}
            size={'small'}
            onClick={handleCreateReport}
            disabled={loading === 'loading' ? true : false}
          />
        </ReportsContentContainer>
      </Container>
    </FacilityFormTemplate>
  )
}

export default ReportsPage
